// import Loadable from 'react-loadable'
// import User from '@/pages/user/index.js'
// import Bar from '@/pages/bar/index.js'
import AsyncComponent from "../components/AsyncComponent/index";
// const loadingComponent = ({ error, pastDelay }) => {
// 	// if(error) {
// 	// 	return <div>Error!</div>
// 	// }else if(pastDelay) {
// 	// 	return <div></div>
// 	// }else{
// 	// 	return null
// 	// }
// }
// 路由懒加载
// const loadingComponent = ()=>{
// 	return (
// 		<p></p>
// 	)
// }
const routers = [
  {
    name: "/",
    path: "/",
    exact: true,
    isTab: false,
    meta: {
      title: "首页",
      keepAlive: true,
      backgroundColor: "#fff",
      //auth: true
    },
    component: AsyncComponent(() => import("../pages/shop/GoodsClass.js")),

    // component: Loadable({
    // 	loader: ()=> import ('@/pages/home/index.js'),
    // 	loading:loadingComponent,
    // 	delay: 300
    // })
  },
  {
    name: "Category",
    path: "/category/:pid?",
    exact: true,
    isTab: true,
    meta: {
      title: "产品分类",
      keepAlive: true,
      footer: true,
      backgroundColor: "#fff",
    },
    component: AsyncComponent(() => import("../pages/shop/GoodsClass.js")),
  },
  {
    name: "Cart",
    path: "/cart",
    exact: true,
    isTab: true,
    meta: {
      title: "",
      keepAlive: true,
      footer: true,
      //	auth: true
    },
    component: AsyncComponent(() => import("../pages/shop/ShoppingCart.js")),
  },
  {
    name: "CartDetails",
    path: "/cart_details",
    exact: true,
    isTab: true,
    meta: {
      title: "",
      keepAlive: true,
      footer: true,
      //	auth: true
    },
    component: AsyncComponent(() => import("../pages/shop/CartDetails.js")),
  },
  {
    name: "ViewBill",
    path: "/bill",
    exact: true,
    isTab: true,
    meta: {
      title: "",
      keepAlive: true,
      footer: true,
      //	auth: true
    },
    component: AsyncComponent(() => import("../pages/shop/Bill.js")),
  },
  {
    name: "User",
    path: "/user",
    exact: true,
    isTab: true,
    meta: {
      title: "个人中心",
      keepAlive: true,
      footer: true,
      //auth: true
    },
    component: AsyncComponent(() => import("../pages/user/user.js")),
  },
  {
    path: "/user/data",
    name: "PersonalData",
    meta: {
      title: "个人资料",
      keepAlive: true,
      //	auth: true
    },
    component: AsyncComponent(() => import("../pages/user/personalData.js")),
  },
  {
    path: "/user/binding",
    name: "BindingPhone",
    meta: {
      title: "绑定手机",
      keepAlive: true,
      backgroundColor: "#fff",
      // auth: true
    },
    component: AsyncComponent(() => import("../pages/user/bindingPhone.js")),
  },
  {
    path: "/vote",
    name: "Vote",
    meta: {
      title: "员工评分",
      keepAlive: true,
      // auth: true
    },
    component: AsyncComponent(() => import("../pages/user/userAccount.js")),
  },
  {
    path: "/beneunder",
    name: "Stock",
    meta: {
      title: "Beneunder库存查询",
      keepAlive: true,
      // auth: true
    },
    component: AsyncComponent(() => import("../pages/user/jumpBeneunder.js")),
  },
  {
    path: "/stock",
    name: "Stock",
    meta: {
      title: "进销存管理",
      keepAlive: true,
      // auth: true
    },
    component: AsyncComponent(() => import("../pages/user/jumpStock.js")),
  },
  {
    path: "/stock_search",
    name: "Stock Search",
    meta: {
      title: "VIVAIA库存查询",
      keepAlive: true,
      // auth: true
    },
    component: AsyncComponent(() => import("../pages/user/jumpSearchStock.js")),
  },
  {
    path: "/duo_search",
    name: "Stock Search",
    meta: {
      title: "DUOZOULU库存查询",
      keepAlive: true,
      // auth: true
    },
    component: AsyncComponent(() =>
      import("../pages/user/jumpSearchDuoStock.js")
    ),
  },
  {
    path: "/user/integral",
    name: "Integral",
    meta: {
      title: "积分详情",
      keepAlive: true,
      // auth: true
    },
    component: AsyncComponent(() => import("../pages/user/signIn/integral.js")),
  },
  {
    path: "/user/user_coupon",
    name: "UserCoupon",
    meta: {
      title: "我的优惠券",
      keepAlive: true,
      //  auth: true
    },
    component: AsyncComponent(() => import("../pages/user/userCoupon.js")),
  },
  {
    path: "/user/vip",
    name: "UserVip",
    meta: {
      title: "会员中心",
      keepAlive: true,
      // auth: true
    },
    component: AsyncComponent(() => import("../pages/user/userVip.js")),
  },
  {
    path: "/user/vip",
    name: "UserVip",
    meta: {
      title: "会员中心",
      keepAlive: true,
      // auth: true
    },
    component: AsyncComponent(() => import("../pages/user/userVip.js")),
  },
  {
    path: "/user/user_promotion",
    name: "UserPromotion",
    meta: {
      title: "我的推广",
      keepAlive: true,
      //  auth: true
    },
    component: AsyncComponent(() =>
      import("../pages/user/promotion/userPromotion.js")
    ),
  },
  {
    path: "/user/add_manage",
    name: "AddressManagement",
    meta: {
      title: "地址管理",
      keepAlive: true,
      // auth: true
    },
    component: AsyncComponent(() =>
      import("../pages/user/addressManagement.js")
    ),
  },

  {
    path: "/order/list/:type",
    name: "MyOrder",
    meta: {
      title: "我的订单",
      keepAlive: false,
      // auth: true
    },
    component: AsyncComponent(() => import("../pages/order/myOrder.js")),
  },
  {
    path: "/repair/list/:type",
    name: "MyRepair",
    meta: {
      title: "保修列表",
      keepAlive: false,
      // auth: true
    },
    component: AsyncComponent(() => import("../pages/repair/myRepair.js")),
  },
  {
    path: "/deal_repair/list/:type",
    name: "MyRepair",
    meta: {
      title: "保修列表",
      keepAlive: false,
      // auth: true
    },
    component: AsyncComponent(() => import("../pages/repair/myRepairList.js")),
  },

  {
    path: "/order/detail/:id",
    name: "OrderDetails",
    meta: {
      title: "订单详情",
      keepAlive: false,
      // auth: true
    },
    component: AsyncComponent(() => import("../pages/order/orderDetails.js")),
  },
  {
    path: "/repair/detail/:id",
    name: "RepairDetails",
    meta: {
      title: "报修详情",
      keepAlive: false,
      // auth: true
    },
    component: AsyncComponent(() => import("../pages/repair/repairDetails.js")),
  },
  {
    path: "/deal_repair/detail/:id",
    name: "RepairDetails",
    meta: {
      title: "报修详情",
      keepAlive: false,
      // auth: true
    },
    component: AsyncComponent(() => import("../pages/repair/dealRepair.js")),
  },
  {
    path: "/addRepair",
    name: "AddRepair",
    meta: {
      title: "店面报修",
      keepAlive: false,
      backgroundColor: "#fff",
    },
    component: AsyncComponent(() => import("../pages/repair/addRepair.js")),
  },
  {
    path: "/order/refund_list",
    name: "ReturnList",
    meta: {
      title: "退货列表",
      keepAlive: false,
      //  auth: true
    },
    component: AsyncComponent(() => import("../pages/order/returnList.js")),
  },
  {
    name: "Login",
    path: "/login",
    exact: true,
    meta: {
      title: "登录",
    },
    component: AsyncComponent(() => import("../pages/login/index.js")),
  },

  {
    name: "Login",
    path: "/repair/login",
    exact: true,
    meta: {
      title: "登录",
    },
    component: AsyncComponent(() => import("../pages/repair/login.js")),
  },
  {
    name: "RetrievePassword",
    path: "/retrieve_password",
    exact: true,
    meta: {
      title: "登录",
    },
    component: AsyncComponent(() =>
      import("../pages/login/retrievePassword.js")
    ),
  },
  {
    path: "/search",
    name: "GoodSearch",
    meta: {
      title: "搜索商品",
      keepAlive: true,
      backgroundColor: "#fff",
    },
    component: AsyncComponent(() => import("../pages/shop/search.js")),
  },
  {
    path: "/goods_list",
    name: "GoodsList",
    meta: {
      title: "商品列表",
      keepAlive: true,
    },
    component: AsyncComponent(() => import("../pages/shop/goodsList.js")),
  },
  {
    path: "/collection",
    name: "GoodsCollection",
    meta: {
      title: "收藏商品",
      keepAlive: false,
      //   auth: true
    },
    component: AsyncComponent(() => import("../pages/shop/goodsCollection.js")),
  },
  {
    path: "/user/get_coupon",
    name: "GetCoupon",
    meta: {
      title: "领取优惠券",
      keepAlive: true,
    },
    component: AsyncComponent(() => import("../pages/user/getCoupon.js")),
  },
  {
    path: "/news_list",
    name: "NewsList",
    meta: {
      title: "新闻",
      keepAlive: true,
      backgroundColor: "#fff",
    },
    component: AsyncComponent(() => import("../pages/shop/news/newsList.js")),
  },
  {
    path: "/news_detail/:id",
    name: "NewsDetail",
    meta: {
      title: "新闻详情",
      keepAlive: true,
      backgroundColor: "#fff",
    },
    component: AsyncComponent(() => import("../pages/shop/news/newsDetail.js")),
  },
  {
    path: "/user/sign",
    name: "Sign",
    meta: {
      title: "签到",
      keepAlive: true,
      //  auth: true
    },
    component: AsyncComponent(() => import("../pages/user/signIn/sign.js")),
  },
  {
    path: "/user/sign_record",
    name: "SignRecord",
    meta: {
      title: "签到记录",
      keepAlive: true,
    },
    component: AsyncComponent(() =>
      import("../pages/user/signIn/signRecord.js")
    ),
  },
  {
    path: "/hot_new_goods/:type",
    name: "HotNewGoods",
    meta: {
      title: "热门榜单",
      keepAlive: false,
    },
    component: AsyncComponent(() => import("../pages/shop/hotNewGoods.js")),
  },
  {
    path: "/promotion",
    name: "GoodsPromotion",
    meta: {
      title: "促销单品",
      keepAlive: false,
    },
    component: AsyncComponent(() => import("../pages/shop/goodsPromotion.js")),
  },
  {
    path: "/detail/:id",
    name: "GoodDetail",
    meta: {
      title: "商品详情",
      keepAlive: false,
    },
    component: AsyncComponent(() => import("../pages/shop/goodsDetail.js")),
  },
  {
    path: "/location",
    name: "GoodLocation",
    meta: {
      title: "地图",
      keepAlive: false,
    },
    component: AsyncComponent(() => import("../pages/shop/location.js")),
  },

  {
    name: "NotDefined",
    path: "/error",
    exact: true,
    meta: {
      title: "页面找不到",
      keepAlive: true,
      home: false,
      backgroundColor: "#F4F6FB",
    },
    component: AsyncComponent(() => import("../pages/NotDefined/index.js")),
  },
  {
    name: "Success",
    path: "/success",
    exact: true,
    meta: {
      title: "下单成功",
      keepAlive: true,
      home: false,
      backgroundColor: "#F4F6FB",
    },
    component: AsyncComponent(() => import("../pages/NotDefined/success.js")),
  },
  {
    name: "Payment",
    path: "/payment",
    exact: true,
    meta: {
      title: "在线支付",
      keepAlive: true,
      home: false,
      backgroundColor: "#F4F6FB",
    },
    component: AsyncComponent(() => import("../pages/shop/payment_backup.js")),
  },
  {
    name: "Payment",
    path: "/test",
    exact: true,
    meta: {
      title: "在线支付",
      keepAlive: true,
      home: false,
      backgroundColor: "#F4F6FB",
    },
    component: AsyncComponent(() => import("../pages/shop/payment_test.js")),
  },
  {
    name: "Payment Verify",
    path: "/payment_verify",
    exact: true,
    meta: {
      title: "在线支付",
      keepAlive: true,
      home: false,
      backgroundColor: "#F4F6FB",
    },
    component: AsyncComponent(() => import("../pages/shop/payment_verify.js")),
  },
  {
    name: "Payment",
    path: "/payment_result",
    exact: true,
    meta: {
      title: "在线支付",
      keepAlive: true,
      home: false,
      backgroundColor: "#F4F6FB",
    },
    component: AsyncComponent(() => import("../pages/shop/payment_result.js")),
  },
  {
    name: "PrivacyPolicy",
    path: "/privacyPolicy",
    meta: {
      title: "隐私条款",
      keepAlive: false,
    },
    component: AsyncComponent(() => import("../pages/privacyPolicy/index.jsx")),
  },
];
export default routers;
